import { HttpClient, HttpParams } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, OnDestroy, OnInit, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { GtwElementsBaseUrlsModel } from '../../../shared/_models/gtw-elements-base-urls.model';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import {
  generalConfigFromGlobal,
  hydratedGlobalParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-efile-migration-history',
    templateUrl: './migration-history.component.html',
    styleUrls: ['./migration-history.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MigrationHistoryComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  baseURLs: GtwElementsBaseUrlsModel = { admin: '', api: '', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
  globalService: any = {};
  rowData: any = {};

  loading = false;
  rows: any[] = [];

  constructor(
    private http: HttpClient,
    private snackbar: GtwSnackbarService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext())
    );
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext())
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const gc = generalConfigFromGlobal(this.gtwGlobal);
    this.baseURLs = {
      api: gc.api,
      admin: gc.admin,
      custom: gc.custom,
      efile: gc.efile,
      pdfEngine: gc.pdfEngine,
      bulkPdfEngine: gc.bulkPdfEngine,
    };
    this.globalService = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.tryLoad();
  }

  private tryLoad(): void {
    if (!this.baseURLs.admin) return;
    this.loadHistory();
  }

  private loadHistory(): void {
    const taxYear = this.rowData?.TAX_YEAR || this.globalService?.tax_year || '';
    if (!taxYear) return;

    this.loading = true;
    const params = new HttpParams().set('tax_year', String(taxYear));
    this.http.post<any>(`${this.baseURLs.admin}/efile/getMigrationHistory`, null, { params, withCredentials: true }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res?.callSuccess) {
          this.rows = res?.eFileMigrationList || [];
          return;
        }
        this.rows = [];
        this.snackbar.openSnackBar(res?.errorMessage || 'Unable to load migration history', 'gtw-snackbar--red');
      },
      error: () => {
        this.loading = false;
        this.rows = [];
        this.snackbar.openSnackBar('Unable to load migration history', 'gtw-snackbar--red');
      }
    });
  }
}
